import { styled } from "@mui/material";

export const LoginWallpaper = styled("div")(({ theme }) => ({
  backgroundImage: 'url("/images/crm-background.webp")',
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  width: "100%",
  height: "100%",
}));
